
/**
 * Cache to register contract types
 * @kind cache
 * @class ContractTypeLookup
 * @description Custom lookup cache for ContractTypeLookup
 * @usage let lookup = await Grape.cache.get('ContractTypeLookup');
 */
export default {
	name: 'ContractTypeLookup',
	options: {
		schema: 'public',
		table: 'contract_type'
	}
};
